/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { ReportTypes } from '../../enums';
import { fetchReportByType } from './actions';

const initialState = {
  [ReportTypes.OverallPerformance]: {
    loading: false,
    error: false,
    message: '',
    report: null,
  },
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchReportByType.pending, (state, { meta }) => {
      const { type } = meta.arg;
      state[type].loading = true;
    });
    builder.addCase(fetchReportByType.fulfilled, (state, { payload, meta }) => {
      const { type } = meta.arg;
      state[type].loading = false;
      state[type].report = payload;
    });
    builder.addCase(fetchReportByType.rejected, (state, { meta, error }) => {
      const { type } = meta.arg;
      state[type].loading = false;
      state[type].error = true;
      state[type].message = error?.message || '';
      Sentry.captureException(error);
    });
  },
});

export default reportsSlice.reducer;
